
export enum INVESTOR_DOCUMENT_TYPE {
  // UTILITY_BILL = 'utility_bill',
  BANK_STATEMENT = 'bank_statement',
  ID_CARD = 'id_card',
  PASSPORT = 'passport',
  COMPANY_REG_DOC = 'company_registration_document',
}
